import React  from 'react';
import PropTypes from 'prop-types';

const LogoutIcon = (props) => {
  const { width, height, isActive } = props;
  let color;
  if (!isActive) {
    color = '#AEB2BF';
  }
  else {
    color = '#FF4200';
  }

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 24 23">
      <path fill={color} d="M8 22.142a.988.988 0 0 1-.581-.187l-7-5A.997.997 0 0 1 0 16.142v-15a1 1 0 0 1 1-1c.388 0 1.185.624 1.316.718l6.266 4.484c.262.19.418.491.418.814v14.984a1.001 1.001 0 0 1-1 1z"/>
      <path fill={color} d="M24 9.142l-6-5v4h-4v-7a1 1 0 0 0-1-1H4.751l4.995 3.576A3.013 3.013 0 0 1 11 6.158v10.984h2a1 1 0 0 0 1-1v-6h4v4l6-5z"/>
    </svg>
  );
};

LogoutIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  isActive: PropTypes.bool,
};

LogoutIcon.defaultProps = {
  width: 24,
  height: 23,
  isActive: false,
};

export default LogoutIcon;
